import { useState, memo } from "react";
import { Row, Col, Nav, Navbar } from "react-bootstrap";

import { useAppDispatch, useAppSelector } from "../store/hooks";
import { signOut } from "../store/authSlice";

import Logo from "../image/logoYounicam.png";
import ConfirmModal from "./ConfirmModal";

import styled from "styled-components";
import ButtonComponent from "./ButtonComponent";
import { Link } from "react-router-dom";

const StyledNavbar = styled(Navbar)`
  background-color: ghostwhite;
  margin-top: 10px;
  box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  padding: 1vh;
  border-radius: 4px;

  .navbar-light .navbar-nav .nav-link:hover {
    color: black;
    text-decoration: underline;
  }
`;

const NavText = styled(Navbar.Text)`
  @media (min-width: 767px) {
    border-right: solid 0.2px;
    border-color: rgba(0, 0, 0, 0.55);
    padding-right: 0.5rem;
  }
`;

const NavLink = styled(Link)`
  :hover {
    text-decoration: underline;
  }
`;

const NavbarComponent = () => {
  const [modal, setModal] = useState(false);
  const username = useAppSelector((state) => state.auth.user.username);
  const authorized = useAppSelector((state) => state.auth.user.authorized);

  const dispatch = useAppDispatch();

  return (
    <>
      <ConfirmModal
        title="Sign out"
        text="Proceed to sign out?"
        show={modal}
        onClose={setModal}
        onClick={() => dispatch(signOut())}
      />
      <Row>
        <Col>
          <StyledNavbar
            collapseOnSelect
            expand="md"
            className="navStyle"
            bg="light"
            variant="light"
          >
            <Navbar.Brand>
              <img
                src={Logo}
                width="45"
                height="45"
                className="d-inline-block align-top"
                alt="Brand Logo"
              />
            </Navbar.Brand>
            <NavText>YoUnicam Dashboard</NavText>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={NavLink} to="/">
                  Channels
                </Nav.Link>
                {authorized && (
                  <Nav.Link as={NavLink} to="/presences">
                    Presences
                  </Nav.Link>
                )}
              </Nav>
              <Nav>
                <Navbar.Text>
                  <i className="fas fa-user"></i>{" "}
                  <b style={{ paddingRight: "1vh" }}>{username}</b>
                  <ButtonComponent
                    variant="outline-danger"
                    onClick={() => setModal(true)}
                  >
                    <i className="fas fa-sign-out-alt"></i>
                  </ButtonComponent>
                </Navbar.Text>
              </Nav>
            </Navbar.Collapse>
          </StyledNavbar>
        </Col>
      </Row>
    </>
  );
};

export default memo(NavbarComponent);
